module.exports = __webpack_public_path__ + "img/home_logo.d13e09fa.png";